import { gql } from '@apollo/client';

export const LOGOUT_MUTATION = gql`
    mutation logoutUser($refreshToken: String!, $userId: String!) {
        logoutUser(refreshToken: $refreshToken, userId: $userId) {
            message
        }
    }
`;
